import React from 'react';
import PropTypes from 'prop-types';

const PreloadStylesheet = ({
  styleHref, styleSheetHref, isVortexEnabled, locale,
}) => {
  if (styleHref === styleSheetHref.dls7) {
    if (locale === 'en-US' && isVortexEnabled) {
      return (<link rel="preload" href={styleSheetHref.vortexDls6} as="style" />);
    }
    return (<link rel="preload" href={styleSheetHref.dls6} as="style" />);
  }
  return (<link rel="preload" href={styleSheetHref.dls7} as="style" />);
};

PreloadStylesheet.propTypes = {
  styleHref: PropTypes.string.isRequired,
  isVortexEnabled: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  styleSheetHref: PropTypes.shape({
    vortexDls6: PropTypes.string.isRequired,
    dls6: PropTypes.string.isRequired,
    dls7: PropTypes.string.isRequired,
  }).isRequired,
};

export default PreloadStylesheet;
